function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
// ----------------------------------------------------------------------------
// Section: Product Details
// ----------------------------------------------------------------------------
// Listens for variant changes and dynamically updates variant-specific
// metafields using Shopify's section rendering API.
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import { initializeAccordion } from 'snippets/_containers/accordion/accordion';
import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
import { sectionRendering } from 'scripts/helpers/iamota-shopify-ajax';
import { getUrlWithVariant } from '@shopify/theme-product-form';

// Styles
import './_product-details.scss';

// -------------------------------------
// Product Details Section Component
// -------------------------------------

class IamProductDetails extends HTMLElement {
  constructor() {
    super();
    this.pendingVariantId = null;
  }
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.productUrl = this.dataset.productUrl;
    if (!this.sectionId || !this.productUrl) {
      console.warn('Product details section missing required data attributes');
      return;
    }

    // Subscribe to variant change events from the product form
    iamotaEventHandler.subscribe('productForm:variant:changed', this.onVariantChange.bind(this), {
      source: 'product-details'
    });
  }
  onVariantChange(_ref) {
    var variant = _ref.variant;
    if (!(variant !== null && variant !== void 0 && variant.id)) return;
    this.updateContent(variant.id);
  }
  updateContent(variantId) {
    var _this = this;
    return _asyncToGenerator(function* () {
      // Track the pending variant to prevent race conditions
      _this.pendingVariantId = variantId;
      _this.classList.add('is-loading');
      try {
        // Build URL with variant parameter
        var pageUrl = getUrlWithVariant(_this.productUrl, variantId);

        // Fetch updated section HTML with the new variant context
        var sectionHtml = yield sectionRendering.fetchSingle(_this.sectionId, pageUrl);

        // Check if this request is still relevant (user might have changed variants again)
        if (_this.pendingVariantId !== variantId) return;

        // Parse the HTML response
        var parser = new DOMParser();
        var doc = parser.parseFromString(sectionHtml, 'text/html');
        var newSection = doc.querySelector("#product-details-".concat(_this.sectionId));
        if (newSection) {
          // Update desktop layout
          var newDesktop = newSection.querySelector('.product-details__desktop');
          var currentDesktop = _this.querySelector('.product-details__desktop');
          if (newDesktop && currentDesktop) {
            currentDesktop.innerHTML = newDesktop.innerHTML;
          }

          // Update mobile accordion
          var newAccordion = newSection.querySelector('.accordion');
          var currentAccordion = _this.querySelector('.accordion');
          if (newAccordion && currentAccordion) {
            // Store currently open accordion states
            var openItems = Array.from(currentAccordion.querySelectorAll('.js-accordion__item.is-open')).map(item => item.id);

            // Update content
            currentAccordion.innerHTML = newAccordion.innerHTML;

            // Re-initialize accordion event listeners
            initializeAccordion(currentAccordion);

            // Re-open previously open accordion items
            openItems.forEach(id => {
              var item = currentAccordion.querySelector("#".concat(id));
              if (item) {
                item.classList.add('is-open');
                var content = item.querySelector('.js-accordion__content');
                var button = item.querySelector('.js-accordion__button');
                if (content) {
                  content.hidden = false;
                  content.style.height = content.scrollHeight + 'px';
                }
                if (button) button.setAttribute('aria-expanded', 'true');
              }
            });
          }
        }
      } catch (error) {
        console.error("Failed to update product details for variant ".concat(variantId, ":"), error);
      } finally {
        // Only remove loading state if this is still the current pending request
        if (_this.pendingVariantId === variantId) {
          _this.classList.remove('is-loading');
          _this.pendingVariantId = null;
        }
      }
    })();
  }
}
customElements.define('iam-product-details', IamProductDetails);